import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { Validators } from "../../../../../shared/validators";
import { CustomValidators } from "../../../../../shared/custom-validators";
import { GetSellerRoleService } from "../../services/get-seller-role.service";
import { CreateMemberTeamService } from "../../services/create-member-team.service";
import { GetMemberTeamService } from "../../services/get-team-member.service";
import { UpdateMemberRoleService } from "../../services/update-member-role.service";
import { RolesService } from "../../services/roles.service";
import { LanguageService } from "../../../../../shared/services/language.service";
import { Organization } from "src/app/dashboard/Organization";
import { GetOrganizationService } from "src/app/shared/services/get-organization";
import { AssignMemberOrganizationService } from "src/app/shared/services/assign-member-organization";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: 'app-add-member',
  templateUrl: './add-member.component.html',
  styleUrls: ['./add-member.component.scss']
})
export class AddMemberComponent implements OnInit, AfterViewInit {
  TeamMemberForm!: FormGroup;
  success: boolean = false;
  textOnlyPattern = /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z-_\.]*$/;
  editMode: boolean = false;
  roles: { id: number; name: string }[] = [];
  formValidator = new FormValidatorService();
  validationError!: [
    {
      field: string;
      message: string;
      validation: string;
    }
  ];
  rolePermissions: any;
  selectedRole: any;
  public orgData: any[] = [];

  constructor(
    private rolesFetch: GetSellerRoleService,
    private createMemberTeamService: CreateMemberTeamService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private getMemberTeamService: GetMemberTeamService,
    private updateMemberRoleService: UpdateMemberRoleService,
    private getRoleDetailsService: RolesService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private authService: AuthService,
    public getOrganizationService: GetOrganizationService,
    public assignMemberOrganizationService: AssignMemberOrganizationService,
  ) { }

  async ngOnInit() {
    if (localStorage.getItem('language') === 'ar') {
      this.translate.use('ar');
    } else {
      this.translate.use('en');
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    })
    this.activatedRoute.params.subscribe(async a => {
      if (a["token"]) {
        this.editMode = true;
        this.getMemberTeamService.setParams({ token: a["token"] });
        const response = await this.getMemberTeamService.make();
        console.log(response);
        await this.initForm();

        this.TeamMemberForm.controls["firstName"].setValue(
          response.TeamMemeber.firstName
        );
        this.TeamMemberForm.controls["lastName"].setValue(
          response.TeamMemeber.lastName
        );

        this.TeamMemberForm.controls["email"].setValue(
          response.TeamMemeber.email
        );

        this.TeamMemberForm.controls["roleId"].setValue(
          response.TeamMemeber.roleId
        );

        this.TeamMemberForm.controls["businessIds"].setValue(
          response?.TeamMemeber?.organization?.requestedIds
        );
      } else {
        this.initForm();
      }
    });
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {

      this.formValidator.validationMessages = {
        "firstName": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'First name',
            fieldAr: 'الإسم الأول'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'First name',
            fieldAr: 'الإسم الأول'
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'First name',
            fieldAr: 'الإسم الأول',
            value: 2
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'First name',
            fieldAr: 'الإسم الأول',
            value: 20
          }),
        },
        'lastName': {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير'
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير',
            value: 2
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير',
            value: 20
          }),
        },
        "email": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Email',
            fieldAr: 'البريد الإلكتروني'
          }),
          email: this.translate.instant('FormValidation.ValidEmail'),
        },
        "roleId": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Team Member Role',
            fieldAr: 'دور عضو الفريق'
          }),
        },
      }
    });
  }

  async initForm() {
    this.TeamMemberForm = this.formValidator.createForm([
      {
        fieldName: "firstName",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(/(?!^\d+$)^.+$/g),
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(this.textOnlyPattern),
            message: ''
          },
          {
            validatorFn: Validators.minLength(2),
            message: ''
          }
        ]
      },
      {
        fieldName: "lastName",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(/(?!^\d+$)^.+$/g),
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(this.textOnlyPattern),
            message: ''
          },
          {
            validatorFn: Validators.minLength(2),
            message: ''
          }
        ]
      },
      {
        fieldName: "email",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: Validators.email,
            message: ''
          }
        ]
      },
      {
        fieldName: "roleId",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: "businessIds",
        defaultValue: [],
        validators: []
      },
    ]);

    try {
      const res = await this.rolesFetch.make();
      await this.createTable();
      this.roles = res;
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  }

  async onSubmit() {
    try {
      if (this.editMode) {
        this.editMode = false;
        this.updateMemberRoleService.setParams({
          email: this.TeamMemberForm.value.email,
          roleId: this.TeamMemberForm.value.roleId
        });

        this.assignMemberOrganizationService.setParams({
          businessIds: this.TeamMemberForm.value.businessIds,
          userEmail: this.TeamMemberForm.value.email,
        })
        await this.updateMemberRoleService.make();
        await this.assignMemberOrganizationService.make();
        this.router.navigate(["/seller/team/mangement"]);
      } else {
        this.createMemberTeamService.setParams(this.TeamMemberForm.value);

        const res = await this.createMemberTeamService.make();
        console.log(res);
        this.router.navigate(["/seller/team/mangement"]);
      }
    } catch (errors) {
      console.log(errors);
      this.validationError = errors.validationErrors.error;
      for (const e of this.validationError) {
        this.formValidator.addError(e.field, "invalid", e.message);
        this.TeamMemberForm.controls[e.field].setErrors({ invalid: e.message });
        this.formValidator.ShowErrors();
      }
    }
  }

  async onRoleChange(newValue: any) {
    this.getRoleDetailsService.setParams({ id: newValue });
    const response = await this.getRoleDetailsService.make();
    this.rolePermissions = response.Permissions;
    console.log(response);
    return response;
  }

  convertControls(name: string) {
    return this.TeamMemberForm.controls[name];
  }

  private async createTable(): Promise<void> {
    const res = await this.getOrganizationService.make();
    const mainBusiness = await this.authService.getBusiness();
    this.orgData.push({ businessName: mainBusiness.name, id: mainBusiness.id });
    if (res.success) {
      (res.data as Organization[]).map((e) => {
        if (e.Business) {
          this.orgData.push({ businessName: e.Business.name, id: e.BusinessId });
        }
      });
    }
  }
}
